import React from 'react';
import { FileText, Calendar } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

export const AtualizacoesLegislativasPage = () => {
  const atualizacoes = [
    {
      id: 1,
      titulo: 'Lei 14.438/2022 - Programa Auxílio Brasil',
      data: '2025-01-05',
      resumo: 'Estabelece o Programa Auxílio Brasil e o Auxílio Gás dos Brasileiros.'
    },
    {
      id: 2,
      titulo: 'Lei 14.436/2022 - Marco Legal das Garantias',
      data: '2025-01-03',
      resumo: 'Dispõe sobre o Marco Legal das Garantias e moderniza o sistema de garantias brasileiro.'
    }
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Atualizações Legislativas
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Acompanhe as mudanças mais recentes na legislação brasileira
            </p>
          </div>
        </section>

        {/* Updates List */}
        <section className="py-16 md:py-20">
          <div className="max-w-5xl mx-auto px-6">
            <div className="space-y-6">
              {atualizacoes.map((item) => (
                <Card key={item.id} className="overflow-hidden hover:shadow-xl transition-shadow duration-300 border-0">
                  <CardContent className="p-6 bg-white">
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0 w-12 h-12 bg-[#B49163] rounded-lg flex items-center justify-center">
                        <FileText size={24} className="text-white" />
                      </div>
                      <div className="flex-grow">
                        <h3 className="text-xl font-serif font-semibold text-[#0F172A] mb-2">
                          {item.titulo}
                        </h3>
                        <p className="text-gray-600 mb-3">
                          {item.resumo}
                        </p>
                        <div className="flex items-center gap-2 text-sm text-gray-500">
                          <Calendar size={16} />
                          <span>{new Date(item.data).toLocaleDateString('pt-BR')}</span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default AtualizacoesLegislativasPage;